import useIsDesktop from "@hooks/useIsDesktop"

import ViewBarPortal from "@organisms/ViewBar/ViewBarPortal/ViewBarPortal"

import { ViewBarFiltersBarProps } from "./ViewBarFiltersBar.types"

export default function ViewBarFiltersBar(props: ViewBarFiltersBarProps) {
    const { children } = props

    const isDesktop = useIsDesktop()

    if (isDesktop) {
        return <ViewBarPortal>{children}</ViewBarPortal>
    } else {
        return null
    }
}
